import { PROMOTION_PRIORITY } from '../constants/index';

const getRewardDetails = (promo) => {
  const { longDesc, promoType } = promo || {};
  const rewardLevel = promoType === 'ORDERPROMO' ? 'ORDER' : 'ITEM';
  if (longDesc?.includes('%')) {
    const percentMatch = longDesc?.match(/(\d+)%/);
    return {
      rewardVal: percentMatch ? percentMatch[1] : '',
      rewardType: 'PERCNTOFF',
      rewardLevel
    };
  }
  if (longDesc?.includes('$')) {
    const dollarMatch = longDesc.match(/\$(\d+)/);
    return {
      rewardVal: dollarMatch ? dollarMatch[1] : '',
      rewardType: 'AMTOFF',
      rewardLevel
    };
  }
  return {};
};

const getPromotionByPriority = (promotions) => {
  const priorityPromotion = PROMOTION_PRIORITY?.map((priority) => {
    return promotions?.find((promo) => promo?.promotionTags?.[0] === priority);
  })?.filter((promos) => !!promos);
  return priorityPromotion;
};

const getProductFromPromoId = (products, promoId) => {
  return products?.find((product) =>
    product?.pricing?.conditionalPromotions?.find((promo) => promo?.promotionId === promoId)
  );
};

const getPromoExistsInProducts = (orderedPromotions, products) => {
  return orderedPromotions?.find((orderedPromo) => {
    const promoId = orderedPromo?.promoId ? Number(orderedPromo?.promoId) : null;
    if (!promoId) {
      return false;
    }
    return getProductFromPromoId(products, promoId);
  });
};

const getPromoDetailsfromProducts = (adjustments, products) => {
  const orderedPromotions = getPromotionByPriority(adjustments?.promotions || []);

  if (!orderedPromotions?.length) {
    return [];
  }
  const selectedPromo = getPromoExistsInProducts(orderedPromotions, products);

  if (selectedPromo) {
    const selectedPromoId = selectedPromo?.promoId ? Number(selectedPromo?.promoId) : null;
    return getProductFromPromoId(products, selectedPromoId)?.pricing?.conditionalPromotions;
  }

  const { rewardVal, rewardType, rewardLevel } = getRewardDetails(orderedPromotions?.[0]) || {};
  const defaultPromo = [{
    promotionId: orderedPromotions?.[0].promoId,
    promotionTags: orderedPromotions?.[0].promotionTags,
    reward: {
      tiers: [{
        thresholdType: 'QUANTITY',
        rewardVal,
        rewardType,
        rewardLevel,
        minThresholdVal: 1
      }]
    }
  }];
  return defaultPromo;
};

export const transformBundlePromotion = (products, adjustments) => {
  if (!adjustments?.promotions?.length) {
    return null;
  }
  const conditionalPromotions = getPromoDetailsfromProducts(adjustments, products);

  return {
    product: {
      pricing: {
        conditionalPromotions
      }
    }
  };
};
